import axios, { AxiosError } from 'axios';

import type { Response } from 'src/interfaces/Response';

export type AddressFileUploadResponse = Response<string>;

export const uploadAddressFileUri =
	'/api/gtdcm/v1/rate-files/upload-address-file';
export async function uploadAddressFile(locationMappingId: number, file: File) {
	const formData = new FormData();

	formData.append('locationMappingId', locationMappingId.toString());
	formData.append('file', file);

	try {
		const response = await axios.post<AddressFileUploadResponse>(
			uploadAddressFileUri,
			formData
		);

		return response.data.data;
	} catch (error: unknown) {
		if (error instanceof AxiosError) {
			throw error.response?.data;
		}

		throw error;
	}
}
